import React from "react";
import Layout from "../components/Layout";

export default function Terms() {
  return (
    <Layout>
      <div className="section-pad max-w-3xl mx-auto">
        <h1 className="font-display text-4xl font-semibold text-brand-ink">Terms of Service</h1>
        <div className="mt-6 space-y-4 text-brand-inksoft leading-relaxed">
          <p>Welcome to Zenergize Holistic Health Club. By creating an account you agree to these terms.</p>
          <p><strong>Medical Disclaimer.</strong> Isoharts is a 501(c)(3) spiritually based nonprofit organization. All education is for personal benefit and self development. Nothing offered here is intended to diagnose, treat, cure, or prevent any disease, and it is not a substitute for professional medical advice. Always consult a qualified healthcare provider.</p>
          <p><strong>Memberships.</strong> Gold Genesis and Diamond Dharma are one-time, lifetime purchases at launch pricing. Silver Serenity is free. Access tiers are cumulative.</p>
          <p><strong>Content.</strong> All videos, guides, and teachings are for your personal use and may not be redistributed.</p>
          <p><strong>Consultations.</strong> Included consultation credits are allotted per membership period and are non-transferable.</p>
        </div>
      </div>
    </Layout>
  );
}
